import { SMTP_SETTINGS } from '../constant/actionTypes';

const getSmtpSettings = (state, action) => {
  switch (action.type) {
    case SMTP_SETTINGS.GET.INITIATE:
      return { isFetching: true, data: action.payload };
    case SMTP_SETTINGS.GET.SUCCESS:
      return { isFetching: false, data: action.payload };
    case SMTP_SETTINGS.GET.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return (typeof state === 'undefined') ? {} : state;
  }
};

export default getSmtpSettings;
